import { render, staticRenderFns } from "./CommonSchoolSearch.vue?vue&type=template&id=38128d44"
import script from "./CommonSchoolSearch.vue?vue&type=script&lang=js"
export * from "./CommonSchoolSearch.vue?vue&type=script&lang=js"
import style0 from "./CommonSchoolSearch.vue?vue&type=style&index=0&id=38128d44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports